type LinkingProvider = 'plaid' | 'passiv' | 'sharesight';

export class PortfolioLinkingSDKError extends Error {
  message: string;
  provider: LinkingProvider;
  code: string;
  error: unknown;

  constructor(
    provider: LinkingProvider,
    message: string,
    error: unknown,
    errorCode: string
  ) {
    super();
    this.message = message;
    this.provider = provider;
    this.error = error;
    this.code = errorCode;
  }
}

export const isPortfolioLinkingSDKError = (
  error: unknown
): error is PortfolioLinkingSDKError => {
  if (error === null || typeof error === 'undefined') return false;
  if (error instanceof Error) {
    if (
      'message' in error &&
      'provider' in error &&
      'code' in error &&
      'error' in error
    ) {
      const { message, provider } = error;
      return typeof message === 'string' && typeof provider === 'string';
    }
  }
  return false;
};
